import { sanitizeFileName } from './sanitizeFileName';

interface FlutterFile {
  name: string;
  path: string;
  size: number;
  extension: string;
  base64?: string;
  uploadByFlutter?: boolean; // Flutter가 직접 업로드할지 여부
}

interface FlutterFileData {
  name: string;
  path: string;
  size: number;
  extension: string;
  base64?: string;
  file?: File;
  uploadByFlutter?: boolean;
}

export const handleFlutterLogout = () => {
  if (window.FlutterWebView) {
    window.FlutterWebView.postMessage('handleLogout');
  }
};

export const handleFlutterLogoutAndRemoveCookies = () => {
  if (window.FlutterWebView) {
    window.FlutterWebView.postMessage('handleLogoutAndRemoveCookies');
    return true;
  }
  return false;
};

const isMobile = (): boolean => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const ua = navigator.userAgent;
const isIOS = /iPhone|iPad|iPod/i.test(ua); // iOS 여부
const isIpadOS = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1; // iPadOS 여부
const isSafari = /Safari/i.test(ua) && !/CriOS|FxiOS|OPiOS|mercury/i.test(ua); // Safari 여부
const isNaver = /NAVER/i.test(ua); // 네이버 앱 여부

const isIOSSafari = (): boolean => (isIOS || isIpadOS) && isSafari;
const isIOSNaver = (): boolean => (isIOS || isIpadOS) && isNaver;

export const downloadFile = async (fileUrl: string, filename: string): Promise<void> => {
  // IOS이면서도 네이버 앱일 경우, IOS 네이버 앱 v12 이상 부터 지원
  if (isIOSNaver()) {
    window.location.href = fileUrl;

    // 프로그래밍 방식 다운로드 (동일 출처일 때만 작동)
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = 'image_name.jpg'; // 다운로드될 파일명
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    return;
  }

  // 네이버 앱일 경우: 새 창을 열고 이미지를 보여줌
  if (isNaver) {
    const newWindow = window.open();
    if (newWindow) {
      newWindow.document.write(`
        <div style="text-align:center; padding:20px;">
          <p style="font-size:16px; margin-top:20px; text-align:center;">아래 이미지를 꾹 눌러서<br><b>[내 휴대폰에 저장]</b>을 선택해 주세요.</p>
          <img src="${fileUrl}" style="max-width:100%; border:1px solid #ccc;" />
        </div>
      `);
      window.alert(`이미지를 꾹 눌러서 \n[내 휴대폰에 저장]을 선택해 주세요.`);
      newWindow.document.title = filename;
    } else {
      // 팝업 차단 시 현재 창 전환
      window.location.href = fileUrl;
    }
    return;
  }

  // 사파리일 경우 새 창을 열어서 이미지를 보여주고, 사진 앱에 저장을 선택하도록 안내
  if (isIOSSafari()) {
    // 1. 새 창을 먼저 엽니다. (URL 없이 열어둠)
    const newWindow = window.open('', '_blank');

    // 팝업 차단 시 현재 창 전환
    if (!newWindow) {
      window.alert('설정 > 앱 > Safari > 팝업차단 활성화를 해제 해주세요.');
      // window.open(fileUrl, '_blank');
      return;
    }

    // 2. 새 창에 채울 HTML 소스 생성
    const htmlContent = `
      <!DOCTYPE html>
      <html lang="ko">
        <head><meta charset="utf-8"><title>${filename}</title></head>
        <body style="margin:0; display:flex; flex-direction:column; align-items:center; justify-content:center; height: auto; min-height: 100vh;">
          <p style="font-size:16px; margin-top:20px; text-align:center;">아래 이미지를 꾹 눌러서<br><b>[사진 앱에 저장]</b>을 선택해 주세요.</p>
          <div style="text-align:center; padding:20px;">
            <img src="${fileUrl}" style="max-width:100%; border:1px solid #ccc;" />
          </div>
        </body>
      </html>
    `;

    // 3. Blob을 사용하여 새 창의 내용을 채움
    const blob = new Blob([htmlContent], { type: 'text/html' });
    const blobUrl = URL.createObjectURL(blob);

    newWindow.location.href = blobUrl;
    return;
  }

  if (window.FileDownloader) {
    await window.downloadFile?.(fileUrl, filename);
    return;
  }

  // iOS Safari는 download 속성을 지원하지 않으므로 특별 처리
  // if (isIOSSafari()) {
  //   window.open(fileUrl, '_blank');
  //   // try {
  //   //   const response = await fetch(fileUrl);
  //   //   if (!response.ok) throw new Error('Network response was not ok');
  //   //   const blob = await response.blob();
  //   //   const url = window.URL.createObjectURL(blob);

  //   //   // iOS Safari에서는 blob URL을 새 창에서 열어서 사용자가 수동으로 저장할 수 있도록 함
  //   //   const newWindow = window.open(url, '_blank');

  //   //   // 새 창이 열리지 않은 경우 (팝업 차단 등) fallback
  //   //   if (!newWindow) {
  //   //     // 대안: 현재 창에서 열기
  //   //     window.location.href = url;
  //   //   }

  //   //   // 메모리 정리는 사용자가 파일을 확인한 후에 수행
  //   //   setTimeout(() => {
  //   //     window.URL.revokeObjectURL(url);
  //   //   }, 60000); // 60초 후 정리
  //   // } catch {
  //   //   // 실패 시 원본 URL로 새 탭 열기
  //   //   window.open(fileUrl, '_blank');
  //   // }
  //   return;
  // }

  // 모바일 및 데스크탑 모두 blob 방식 사용
  // cache: 'no-store' → <img> 미리보기로 캐시된 비-CORS 응답을 재사용하지 않고
  // 항상 Origin 헤더가 포함된 새 요청을 보내 S3가 CORS 헤더를 응답하도록 강제 (간헐적 CORS 차단 방지)
  try {
    const response = await fetch(fileUrl, { cache: 'no-store' });
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.style.display = 'none';
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    // 정리 작업 수행
    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 100);
  } catch {
    window.open(fileUrl, '_blank');
  }
};

export const handleFlutterFile = async (file: FlutterFile, config?: any, allowAllFileTypes: 'all' | 'image' = 'image', uploadByFlutter: boolean = false): Promise<FlutterFileData> => {
  try {
    const fileType = file.extension.toLowerCase();
    const safeFileName = sanitizeFileName(file.name);
    const allowedTypes = ['jpg', 'jpeg', 'png', 'gif', 'svg'];

    if (allowAllFileTypes === 'image' && !allowedTypes.includes(fileType)) {
      throw new Error('지원하지 않는 파일 형식입니다.');
    }

    // Flutter가 업로드를 직접 처리하는 경우(base64 미포함)
    if (uploadByFlutter) {
      return {
        name: safeFileName,
        path: file.path || safeFileName,
        size: file.size,
        extension: fileType,
        uploadByFlutter: true,
      };
    }

    // 기존 base64 흐름 (웹이 직접 파일을 써야 하는 경우)
    if (!file.base64) {
      throw new Error('파일 데이터가 없습니다.');
    }

    if (file.size > 5 * 1024 * 1024) {
      throw new Error('파일 크기는 5MB를 초과할 수 없습니다.');
    }

    const byteString = atob(file.base64.split(',')[1]);
    const mimeString = file.base64.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i += 1) {
      ia[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([ab], { type: mimeString });
    const compressedFile = new File([blob], safeFileName, { type: mimeString });

    return {
      name: safeFileName,
      path: safeFileName,
      size: file.size,
      extension: fileType,
      base64: file.base64,
      file: new File([compressedFile], safeFileName, { type: mimeString }),
    };
  } catch (error) {
    console.error('파일 처리 중 오류:', error);
    throw error;
  }
};

export const setupFlutterFileHandlers = (
  onFileSelected: (fileData: FlutterFileData) => void,
  onError: (error: any) => void,
  config?: any,
  allowAllFileTypes: 'all' | 'image' = 'image',
  uploadByFlutter: boolean = false
) => {
  if (window.FilePicker) {
    window.handleFileSelected = async (file: FlutterFile) => {
      try {
        const fileData = await handleFlutterFile(file, config, allowAllFileTypes, uploadByFlutter);
        onFileSelected(fileData);
      } catch (error) {
        onError(error);
      }
    };

    window.handleFileError = onError;
  }

  return () => {
    window.handleFileSelected = undefined;
    window.handleFileError = undefined;
  };
};

// --- FormSubmit 요청/응답 관리 ---
const pendingFormSubmitMap = new Map<string, (payload: any) => void>();

const generateRequestId = () => (typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : `req_${Date.now()}_${Math.random().toString(16).slice(2)}`);

/**
 * 폼 데이터를 Flutter로 전송하기 위해 변환
 * files 필드와 File 객체를 제외하고 나머지 필드만 반환
 *
 * @param data - 변환할 폼 데이터 (FormData 또는 일반 객체)
 * @returns 변환된 폼 데이터 객체 (files 필드와 File 객체 제외)
 */
export const transformFormData = (data: any): Record<string, any> => {
  // FormData인지 일반 객체인지 확인하여 객체로 변환
  const formObj = data instanceof FormData ? Object.fromEntries(data.entries()) : data;

  // 빈 객체인 경우 경고
  if (!formObj || Object.keys(formObj).length === 0) {
    console.warn('⚠️ transformFormData에 빈 객체가 전달되었습니다.');
    return {};
  }

  // 필터링: files 필드, File 객체, undefined/null 값 제외
  const filtered = Object.entries(formObj).filter(([key, value]) => {
    // files 필드 제외
    if (key === 'files') {
      return false;
    }

    // File 객체 제외
    if (value instanceof File) {
      return false;
    }

    // File 배열 제외
    if (Array.isArray(value) && value.some((item) => item instanceof File)) {
      return false;
    }

    // undefined, null 값 제외
    if (value === undefined || value === null) {
      return false;
    }

    return true;
  });

  return Object.fromEntries(filtered);
};

/**
 * Flutter에 폼 + 첨부파일 업로드 요청을 전달
 *
 * @param params - 업로드 파라미터
 * @param params.url - 절대 URL 또는 상대 경로 (예: '/schedule' 또는 'https://api.example.com/schedule')
 * @param params.endpoint - url과 동일 (url 우선, 없으면 endpoint 사용)
 * @param params.form - 서버로 전송할 폼 데이터 객체 (필수)
 * @param params.fileField - 서버에서 기대하는 파일 필드명 (기본값: 'file')
 * @param params.method - HTTP 메서드 (POST, PATCH, PUT 등, 기본값: 'POST')
 * @param params.requestId - Flutter 콜백을 위한 요청 ID(옵션)
 *
 * @example
 * // 사용 예시:
 * submitFormToFlutter({
 *   url: '/schedule',
 *   method: 'POST', // 또는 'PATCH', 'PUT' 등
 *   form: {
 *     cCd: 'C001',
 *     smName: '일정명',
 *     sDate: '20251101',
 *     // ... 기타 폼 필드들
 *   },
 *   fileField: 'file'
 * });
 */
export const submitFormToFlutter = (params: { url?: string; endpoint?: string; form?: Record<string, any>; fileField?: string; method?: string; requestId?: string }) => {
  if (!window.FormSubmit) {
    console.warn('FormSubmit 채널을 찾을 수 없습니다.');
    return false;
  }

  // url 우선, 없으면 endpoint 사용
  const finalUrl = params.url || params.endpoint;

  if (!finalUrl) {
    console.error('submitFormToFlutter: url 또는 endpoint가 필요합니다.');
    return false;
  }

  // form 데이터 검증 및 정리
  const formData = params.form || {};

  // undefined, null 값 제거 (하지만 빈 문자열은 유지 - 서버가 필수 필드로 기대할 수 있음)
  const cleanedForm = Object.fromEntries(
    Object.entries(formData).filter(([_, value]) => {
      // undefined, null만 제외 (빈 문자열은 유지)
      if (value === undefined || value === null) {
        // console.log(`  ⚠️ submitFormToFlutter에서 제외: ${_} (undefined/null)`);
        return false;
      }
      return true;
    })
  );

  const payload = {
    url: finalUrl,
    method: params.method || 'POST',
    form: cleanedForm,
    fileField: params.fileField || 'file',
    ...(params.requestId ? { requestId: params.requestId } : {}),
  };

  try {
    window.FormSubmit.postMessage(JSON.stringify(payload));
    return true;
  } catch (error) {
    console.error('FormSubmit 전송 실패:', error);
    return false;
  }
};

/**
 * Flutter에 폼을 전송하고, Flutter가 JS로 반환하는 콜백을 Promise로 래핑
 */
export const submitFormToFlutterWithCallback = (params: { url?: string; endpoint?: string; form?: Record<string, any>; fileField?: string; method?: string }) => {
  const requestId = generateRequestId();

  return new Promise((resolve, reject) => {
    pendingFormSubmitMap.set(requestId, (payload) => {
      pendingFormSubmitMap.delete(requestId);
      if (payload?.success) {
        resolve(payload);
      } else {
        reject(payload);
      }
    });

    const ok = submitFormToFlutter({ ...params, requestId });
    if (!ok) {
      pendingFormSubmitMap.delete(requestId);
      reject(new Error('FormSubmit 채널이 없습니다.'));
    }
  });
};

/**
 * Flutter -> JS 콜백 등록
 * Flutter에서 window.handleFormSubmitResult(...) 호출 시 pending map을 resolve/reject
 */
export const setupFlutterFormSubmitHandler = () => {
  if (window.handleFormSubmitResult) return;

  window.handleFormSubmitResult = (payload: any) => {
    try {
      const msg = typeof payload === 'string' ? JSON.parse(payload) : payload;
      const requestId = msg?.requestId;
      if (!requestId) return;
      const cb = pendingFormSubmitMap.get(requestId);
      if (cb) {
        cb(msg);
      } else {
        console.warn('[handleFormSubmitResult] unknown requestId:', requestId);
      }
    } catch (error) {
      console.error('[handleFormSubmitResult] payload parse error:', error, payload);
    }
  };
};

// Flutter WebView의 viewport 설정을 변경
export const setFlutterWebViewViewport = (viewport: string, url?: string): boolean => {
  if (window.FlutterWebView) {
    try {
      if ((window as any).ViewportSetter) {
        // console.log('[setFlutterWebViewViewport] ViewportSetter', (window as any).ViewportSetter);
        (window as any).ViewportSetter.postMessage(
          JSON.stringify({
            url: url || window.location.href,
            viewport,
          })
        );
        return true;
      }
    } catch (error) {
      console.error('Flutter WebView viewport 설정 실패:', error);
      return false;
    }
  }
  return false;
};

// canvas에서 여백 제거 함수
export const trimCanvas = (sourceCanvas: HTMLCanvasElement): HTMLCanvasElement => {
  const ctx = sourceCanvas.getContext('2d');
  if (!ctx) return sourceCanvas;

  const pixels = ctx.getImageData(0, 0, sourceCanvas.width, sourceCanvas.height);
  const { data } = pixels;
  let minX = sourceCanvas.width;
  let minY = sourceCanvas.height;
  let maxX = 0;
  let maxY = 0;

  // 투명하거나 흰색이 아닌 픽셀 찾기 (실제 콘텐츠 영역)
  for (let y = 0; y < sourceCanvas.height; y += 1) {
    for (let x = 0; x < sourceCanvas.width; x += 1) {
      const idx = (y * sourceCanvas.width + x) * 4;
      const r = data[idx];
      const g = data[idx + 1];
      const b = data[idx + 2];
      const a = data[idx + 3];

      // 투명하지 않고, 흰색이 아닌 경우 (여백이 아닌 경우)
      if (a > 0 && !(r === 255 && g === 255 && b === 255)) {
        minX = Math.min(minX, x);
        minY = Math.min(minY, y);
        maxX = Math.max(maxX, x);
        maxY = Math.max(maxY, y);
      }
    }
  }

  // 여백이 없는 경우 원본 반환
  if (minX >= maxX || minY >= maxY) {
    return sourceCanvas;
  }

  // 좌우 여백 추가
  const [pdX, pdY] = [24, 60];
  const trimmedMinX = Math.max(0, minX - pdX);
  const trimmedMinY = Math.max(0, minY - pdY);
  const trimmedMaxX = Math.min(sourceCanvas.width - 1, maxX + pdX);
  const trimmedMaxY = Math.min(sourceCanvas.height - 1, maxY + pdY);

  // 여백을 제거한 새로운 canvas 생성 (좌우 여백 포함)
  const trimmedWidth = trimmedMaxX - trimmedMinX + 1;
  const trimmedHeight = trimmedMaxY - trimmedMinY + 1;
  const trimmedCanvas = document.createElement('canvas');
  trimmedCanvas.width = trimmedWidth;
  trimmedCanvas.height = trimmedHeight;
  const trimmedCtx = trimmedCanvas.getContext('2d');
  if (!trimmedCtx) return sourceCanvas;

  // 원본 canvas에서 여백을 제거한 영역만 복사 (좌우 여백 포함)
  trimmedCtx.drawImage(sourceCanvas, trimmedMinX, trimmedMinY, trimmedWidth, trimmedHeight, 0, 0, trimmedWidth, trimmedHeight);

  return trimmedCanvas;
};
